/* Couleur Safran — fiche produit (Web Component <cs-product>)
 * Variante, galerie, sélecteurs (parfum / destination / duo / packs), vente additionnelle,
 * barre sticky, jauge de livraison, ajout au panier Ajax (/cart/add.js) puis tiroir panier Kalles.
 */
(function () {
  if (customElements.get('cs-product')) return;

  var norm = function (s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[’‘`´]/g, "'").normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  };
  var lines = function (t) { return String(t || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); };
  var uniq = function (a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); };

  class CsProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.init(); } catch (e) { console.error('[cs-product]', e); }
    }

    /* ---------- init ---------- */
    init() {
      var d = (this.d = JSON.parse(this.querySelector('[data-cs-data]').textContent));
      this.nf = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: d.currency || 'EUR' });
      this.si = d.scentIdx; this.ci = d.cityIdx;

      // couleurs / familles / humeurs / packs / correspondances
      this.colors = lines(d.colors).map(function (l) { var i = l.lastIndexOf(':'); return [norm(l.slice(0, i)), l.slice(i + 1).trim()]; })
        .sort(function (a, b) { return b[0].length - a[0].length; });
      this.groups = lines(d.groups).map(function (l) {
        var i = l.indexOf(':'); return { name: l.slice(0, i).trim(), items: l.slice(i + 1).split(',').map(norm).filter(Boolean) };
      });
      this.moods = {};
      lines(d.moods).forEach(function (l) { var p = l.split('|'); if (p[1]) this.moods[norm(p[0])] = p[1].trim(); }, this);
      this.packUnit = String(d.packUnit || 'recharge|recharges').split('|'); if (this.packUnit.length < 2) this.packUnit.push(this.packUnit[0]);
      this.packDisc = d.packDisc ? String(d.packDisc).split(/[;,]/).map(function (x) { return parseFloat(x) || 0; }) : null;
      this.packPrices = String(d.packPrices || '14,26,40').split(',').map(function (x) { return parseFloat(String(x).replace(',', '.')) ; });
      // « 14,26,40 » est ambigu avec la virgule décimale : on accepte aussi « 14;26;40 »
      if (String(d.packPrices).indexOf(';') > -1) this.packPrices = String(d.packPrices).split(';').map(function (x) { return parseFloat(x.replace(',', '.')); });
      this.upMap = {};
      lines(d.upsellMap).forEach(function (l) { var p = l.split('='); if (p[1]) this.upMap[norm(p[0])] = norm(p[1]); }, this);

      this.values = uniq(d.variants.map(function (v) { return v.o[this.si]; }, this));
      this.cities = this.ci > -1 ? uniq(d.variants.map(function (v) { return v.o[this.ci]; }, this)) : [];

      // état
      var cur = d.variants.filter(function (v) { return v.id === d.current; })[0] || null;
      var n = d.options.length;
      this.st = { sel: new Array(n).fill(null), qty: 1, duo: false, scent2: null, slots: [null, null, null], slot: 0, pack: 1, up: false, tab: 0, q: '', slide: 0, box: {} };
      var base = cur || d.variants[0];
      for (var i = 0; i < n; i++) {
        if (i === this.si || i === this.ci) this.st.sel[i] = cur ? cur.o[i] : null; else this.st.sel[i] = base.o[i];
      }
      if (d.mode === 'slots') { this.st.slots[0] = this.st.sel[this.si]; }
      this.st.scent2 = this.values.filter(function (v) { return v !== this.st.sel[this.si]; }, this)[0] || this.values[0];
      var g = this.groupOf(this.st.sel[this.si]); if (g > -1) this.st.tab = g;

      // DOM
      var q = function (s) { return this.querySelector(s); }.bind(this);
      this.el = {
        track: q('[data-cs-track]'), prev: q('[data-cs-prev]'), next: q('[data-cs-next]'), count: q('[data-cs-count]'),
        thumbs: this.querySelectorAll('[data-cs-thumb]'), slides: this.querySelectorAll('.cs-gal__slide'),
        sel: q('[data-cs-sel]'), selDot: q('[data-cs-sel-dot]'), selK: q('[data-cs-sel-k]'), selN: q('[data-cs-sel-n]'),
        price: q('[data-cs-price]'), priceV: q('[data-cs-price-v]'), priceS: q('[data-cs-price-s]'),
        pick: q('[data-cs-pick]'), tabs: q('[data-cs-tabs]'), chips: q('[data-cs-chips]'), search: q('[data-cs-search]'), slots: q('[data-cs-slots]'), same: q('[data-cs-same]'),
        cityPick: q('[data-cs-citypick]'), optPick: q('[data-cs-optpick]'),
        format: q('[data-cs-format]'), duo2: q('[data-cs-duo2]'), chips2: q('[data-cs-chips2]'), duo2Name: q('[data-cs-duo2-name]'), duo2Save: q('[data-cs-duo2-save]'),
        packs: this.querySelectorAll('[data-cs-pack]'),
        up: q('[data-cs-upsell]'), upIn: q('[data-cs-upsell-input]'),
        atc: q('[data-cs-atc]'), cta: q('[data-cs-cta]'), qty: q('[data-cs-qty]'), qtyV: q('[data-cs-qty-v]'), err: q('[data-cs-error]'),
        ship: q('[data-cs-ship]'), shipBar: q('[data-cs-ship-bar]'), shipMsg: q('[data-cs-ship-msg]'),
        sticky: q('[data-cs-sticky]'), stDot: q('[data-cs-sticky-dot]'), stT: q('[data-cs-sticky-t]'), stS: q('[data-cs-sticky-s]'), stCta: q('[data-cs-sticky-cta]'),
        rivCity: q('[data-cs-riv-city]'), rivScent: q('[data-cs-riv-scent]')
      };
      this.hasRiv = !!this.el.rivCity;
      // coffrets : éléments au choix (propriétés de ligne), récapitulatif, message cadeau
      this.boxes = [].slice.call(this.querySelectorAll('[data-cs-box]'));
      this.boxes.forEach(function (bx) { bx.querySelectorAll('[data-cs-box-v]').forEach(function (b) { var dt = b.querySelector('.cs-chip__dot'); if (dt) dt.style.setProperty('--c', this.colorFor(b.dataset.csBoxV)); }, this); }, this);
      this.boxSum = this.querySelector('[data-cs-boxsum]');
      this.note = this.querySelector('[data-cs-note]');
      this.querySelectorAll('.cs-pick__help').forEach(function (h) { h.textContent = h.textContent.replace('{count}', this.values.length); }, this);
      if (this.values.length < 2) { if (this.el.pick) this.el.pick.hidden = true; if (this.el.sel) this.el.sel.hidden = true; }
      this.buildTabs(); this.buildChips(); this.bind(); this.render(true);
      this.watchSticky(); this.loadCart();
    }

    /* ---------- helpers ---------- */
    money(cents) { return this.nf.format(cents / 100); }
    eur(v) { return this.nf.format(v); }
    colorFor(name) {
      var n = norm(name); if (!n) return '#D9CFC0';
      for (var i = 0; i < this.colors.length; i++) if (n === this.colors[i][0]) return this.colors[i][1];
      for (var j = 0; j < this.colors.length; j++) if (n.indexOf(this.colors[j][0]) > -1) return this.colors[j][1];
      return '#D9CFC0';
    }
    groupOf(value) {
      var n = norm(value);
      for (var i = 0; i < this.visibleGroups().length; i++) if (this.visibleGroups()[i].items.indexOf(n) > -1) return i;
      return -1;
    }
    visibleGroups() {
      if (this._vg) return this._vg;
      var nv = this.values.map(norm), used = [];
      var out = this.groups.map(function (g) {
        var items = g.items.filter(function (x) { return nv.indexOf(x) > -1; });
        used = used.concat(items); return { name: g.name, items: items };
      }).filter(function (g) { return g.items.length; });
      var rest = nv.filter(function (x) { return used.indexOf(x) < 0; });
      if (out.length && rest.length) out.push({ name: 'Autres', items: rest });
      return (this._vg = out);
    }
    valueByNorm(n) { return this.values.filter(function (v) { return norm(v) === n; })[0]; }
    variantFor(sel) {
      var d = this.d;
      for (var i = 0; i < d.options.length; i++) if (sel[i] == null) return null;
      return d.variants.filter(function (v) { return v.o.every(function (x, k) { return norm(x) === norm(sel[k]); }); })[0] || null;
    }
    variantOf(scent) { var s = this.st.sel.slice(); s[this.si] = scent; return this.variantFor(s); }
    exists(value) {
      var city = this.ci > -1 ? this.st.sel[this.ci] : null, si = this.si, ci = this.ci;
      return ci < 0 || city == null || this.d.variants.some(function (v) { return norm(v.o[si]) === norm(value) && norm(v.o[ci]) === norm(city); });
    }
    available(value) {
      var city = this.ci > -1 ? this.st.sel[this.ci] : null, si = this.si, ci = this.ci;
      return this.d.variants.some(function (v) { return v.a && norm(v.o[si]) === norm(value) && (ci < 0 || city == null || norm(v.o[ci]) === norm(city)); });
    }
    scentNow() { return this.d.mode === 'slots' ? this.st.slots[this.st.slot] || this.st.slots[0] : this.st.sel[this.si]; }
    packTotal(n, unitCents) {
      if (this.packDisc) return Math.round(unitCents * n * (1 - (this.packDisc[n - 1] || 0) / 100)) / 100;
      return this.packPrices[n - 1] || (unitCents / 100) * n;
    }
    cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
    tpl(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); }

    /* ---------- construction des onglets / puces ---------- */
    buildTabs() {
      var t = this.el.tabs; if (!t) return;
      var gs = this.visibleGroups();
      if (!gs.length || (this.el.chips && this.el.chips.dataset.tabs === 'false')) { t.hidden = true; return; }
      t.innerHTML = '';
      gs.forEach(function (g, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cs-tab'; b.setAttribute('role', 'tab'); b.dataset.i = i;
        b.textContent = g.name + ' · ' + g.items.length;
        t.appendChild(b);
      });
    }
    buildChips() {
      var host = this.el.chips; if (!host) return;
      var moods = host.dataset.moods === 'true', photos = host.dataset.photos === 'true', self = this;
      host.innerHTML = '';
      var order = this.visibleGroups().length ? [].concat.apply([], this.visibleGroups().map(function (g) { return g.items; })) : this.values.map(norm);
      order.forEach(function (n) {
        var v = self.valueByNorm(n); if (!v) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cs-chip'; b.dataset.n = n; b.dataset.v = v; b.setAttribute('aria-pressed', 'false');
        b.innerHTML = '<span class="cs-chip__dot"></span><span class="cs-chip__t"></span>';
        b.querySelector('.cs-chip__dot').style.setProperty('--c', self.colorFor(v));
        if (photos) {
          var pv = self.d.variants.filter(function (x) { return x.i && norm(x.o[self.si]) === n; })[0];
          if (pv) { var im = document.createElement('img'); im.className = 'cs-chip__img'; im.src = pv.i; im.alt = ''; im.loading = 'lazy'; b.classList.add('cs-chip--photo'); b.replaceChild(im, b.querySelector('.cs-chip__dot')); }
        }
        var t = b.querySelector('.cs-chip__t'); t.textContent = v;
        if (moods && self.moods[n]) { var sm = document.createElement('small'); sm.textContent = self.moods[n]; t.appendChild(sm); }
        host.appendChild(b);
      });
      if (this.el.chips2) {
        this.el.chips2.innerHTML = '';
        this.values.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cs-chip'; b.dataset.v = v; b.title = v; b.setAttribute('aria-label', v); b.setAttribute('aria-pressed', 'false');
          b.style.setProperty('--c', self.colorFor(v));
          self.el.chips2.appendChild(b);
        });
      }
      if (this.el.cityPick) {
        this.el.cityPick.querySelectorAll('[data-cs-city]').forEach(function (b) { b.querySelector('i').style.setProperty('--c', self.colorFor(b.dataset.csCity)); });
      }
    }

    /* ---------- événements ---------- */
    bind() {
      var self = this, el = this.el, st = this.st, d = this.d;
      this.addEventListener('click', function (e) {
        var t = e.target.closest('button, a'); if (!t || !self.contains(t)) return;
        if (t.matches('[data-cs-prev]')) return self.go(st.slide - 1);
        if (t.matches('[data-cs-next]')) return self.go(st.slide + 1);
        if (t.matches('[data-cs-thumb]')) return self.go([].indexOf.call(el.thumbs, t));
        if (t.matches('[data-cs-box-v]')) { st.box[t.closest('[data-cs-box]').dataset.prop] = t.dataset.csBoxV; return self.render(false, false); }
        if (t.matches('.cs-tab')) { st.tab = +t.dataset.i; st.q = ''; if (el.search) el.search.value = ''; return self.render(); }
        if (t.matches('.cs-chip') && el.chips && el.chips.contains(t)) return self.pickScent(t.dataset.v);
        if (t.matches('.cs-chip') && el.chips2 && el.chips2.contains(t)) { st.scent2 = t.dataset.v; return self.render(); }
        if (t.matches('[data-cs-city]')) { return self.pickCity(t.dataset.csCity); }
        if (t.matches('[data-cs-fmt]')) { st.duo = t.dataset.csFmt === 'duo'; return self.render(); }
        if (t.matches('[data-cs-pack]')) { st.pack = +t.dataset.csPack; if (st.slot >= st.pack) st.slot = 0; return self.render(); }
        if (t.matches('[data-cs-slot]')) { st.slot = +t.dataset.csSlot; return self.render(); }
        if (t.matches('[data-cs-same]')) { var v = st.slots[st.slot] || st.slots[0] || st.slots.filter(Boolean)[0]; if (v) { for (var i = 0; i < st.pack; i++) st.slots[i] = v; } return self.render(); }
        if (t.matches('[data-cs-inc]')) { st.qty = Math.min(9, st.qty + 1); return self.render(); }
        if (t.matches('[data-cs-dec]')) { st.qty = Math.max(1, st.qty - 1); return self.render(); }
        if (t.matches('[data-cs-cta], [data-cs-sticky-cta]')) return self.action();
      });
      if (el.search) el.search.addEventListener('input', function () { st.q = norm(el.search.value); self.render(); });
      if (el.upIn) el.upIn.addEventListener('change', function () { st.up = el.upIn.checked; self.render(); });
      if (el.track) {
        var raf = 0;
        el.track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { self.onScroll(); }); }, { passive: true });
      }
      // ordres venant des autres sections (cs-ui.js)
      document.addEventListener('cs:pick', function (e) {
        var x = e.detail || {};
        if (x.mode === 'duo' && d.mode === 'duo') st.duo = true;
        if (x.family) { var gi = self.visibleGroups().map(function (g) { return norm(g.name); }).indexOf(norm(x.family)); if (gi > -1) { st.tab = gi; st.q = ''; } }
        if (x.scent) { var v = self.valueByNorm(norm(x.scent)); if (v) self.pickScent(v, true); else self.render(); }
        else self.render();
        if (x.city) self.pickCity(x.city, true);
        if (x.scroll !== false) self.scrollToPick();
      });
    }

    pickScent(v, quiet) {
      var st = this.st, d = this.d;
      if (d.mode === 'slots') {
        st.slots[st.slot] = v;
        var nxt = -1; for (var i = 0; i < st.pack; i++) if (!st.slots[i]) { nxt = i; break; }
        if (nxt > -1) st.slot = nxt;
      } else if (d.mode === 'duo' && st.duo && st.sel[this.si] && this._second) {
        st.scent2 = v;
      } else {
        st.sel[this.si] = v;
      }
      var g = this.groupOf(v); if (g > -1) st.tab = g;
      st.q = ''; if (this.el.search) this.el.search.value = '';
      this.render(false, !quiet);
    }
    pickCity(name, quiet) {
      var n = norm(name), hit = this.cities.filter(function (c) { return norm(c) === n; })[0] ||
        this.cities.filter(function (c) { return norm(c).indexOf(n) > -1 || n.indexOf(norm(c)) > -1; })[0];
      if (!hit) return;
      var st = this.st, self = this; st.sel[this.ci] = hit;
      if (this.d.mode === 'slots') {
        for (var i = 0; i < 3; i++) if (st.slots[i] && !this.exists(st.slots[i])) st.slots[i] = null;
        var fe = -1; for (var j = 0; j < st.pack; j++) if (!st.slots[j]) { fe = j; break; }
        st.slot = fe > -1 ? fe : 0;
      } else if (st.sel[this.si] && !this.exists(st.sel[this.si])) {
        st.sel[this.si] = this.values.filter(function (v) { return self.exists(v); })[0] || null;
      }
      this.render(false, true);
    }
    boxesDone() { var st = this.st; return (this.boxes || []).every(function (bx) { return !!st.box[bx.dataset.prop]; }); }
    firstEmpty() {
      if (!this.boxes || !this.boxes.length) return null;
      var st = this.st, si = this.si;
      var steps = [].slice.call(this.querySelectorAll('[data-cs-box], [data-cs-pick]'));
      return steps.filter(function (x) { return x.hasAttribute('data-cs-box') ? !st.box[x.dataset.prop] : !st.sel[si]; })[0] || null;
    }
    scrollToPick() {
      var t = this.firstEmpty() || this.el.pick || this.el.cityPick; if (!t) return;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      t.classList.add('is-flash'); clearTimeout(this._ft); this._ft = setTimeout(function () { t.classList.remove('is-flash'); }, 1600);
    }

    /* ---------- galerie ---------- */
    go(i) {
      var tr = this.el.track, n = this.el.slides.length; if (!tr) return;
      i = Math.max(0, Math.min(n - 1, i));
      tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
    }
    onScroll() {
      var tr = this.el.track, n = this.el.slides.length;
      var i = Math.max(0, Math.min(n - 1, Math.round(tr.scrollLeft / (tr.clientWidth || 1))));
      this.st.slide = i; this.paintGallery();
    }
    paintGallery() {
      var el = this.el, i = this.st.slide, n = el.slides.length;
      if (el.count) el.count.textContent = (i + 1) + ' / ' + n;
      if (el.prev) el.prev.disabled = i === 0;
      if (el.next) el.next.disabled = i >= n - 1;
      el.thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var on = el.thumbs[i]; if (on && on.parentNode && on.parentNode.scrollTo) on.parentNode.scrollTo({ left: on.offsetLeft - 40, behavior: 'smooth' });
    }
    showVariantMedia(v, instant) {
      if (!v || !v.m || !this.el.track) return;
      var idx = -1; this.el.slides.forEach(function (s, k) { if (+s.dataset.mediaId === v.m) idx = k; });
      if (idx < 0) return;
      var w = this.el.track.clientWidth, cur = Math.round(this.el.track.scrollLeft / (w || 1));
      // pas de défilement lent à travers toute la galerie : saut direct si la photo est loin
      this.el.track.scrollTo({ left: idx * w, behavior: (instant || Math.abs(idx - cur) > 2) ? 'instant' : 'smooth' });
    }

    /* ---------- rendu ---------- */
    render(first, mediaToo) {
      var d = this.d, st = this.st, el = this.el, self = this, mode = d.mode;
      var scent = st.sel[this.si], city = this.ci > -1 ? st.sel[this.ci] : null;
      var isDuo = mode === 'duo' && st.duo;
      this._second = false;

      // variante principale
      var v = mode === 'slots' ? null : this.variantFor(st.sel);
      var complete = mode === 'slots' ? st.slots.slice(0, st.pack).every(Boolean) : !!v;
      if (this.boxes && this.boxes.length) complete = complete && this.boxesDone();
      this.v = v; this.complete = complete;
      var unitCents = v ? v.p : (d.variants[0] ? d.variants[0].p : 0);
      if (mode === 'slots') { var f = st.slots.filter(Boolean)[0]; var fv = f ? this.variantOf(f) : null; if (!fv && city) fv = d.variants.filter(function (x) { return norm(x.o[self.ci]) === norm(city); })[0]; if (fv) unitCents = fv.p; }

      // onglets
      if (el.tabs && !el.tabs.hidden) {
        el.tabs.querySelectorAll('.cs-tab').forEach(function (b) { b.setAttribute('aria-selected', String(+b.dataset.i === st.tab && !st.q)); });
      }
      // puces
      if (el.chips) {
        var gs = this.visibleGroups(), allowed = null;
        if (gs.length && !st.q && !(el.chips && el.chips.dataset.tabs === 'false')) allowed = (gs[st.tab] || gs[0]).items;
        var curS = mode === 'slots' ? st.slots[st.slot] : scent;
        el.chips.querySelectorAll('.cs-chip').forEach(function (b) {
          var n = b.dataset.n, show = st.q ? n.indexOf(st.q) > -1 : (!allowed || allowed.indexOf(n) > -1);
          b.hidden = !show || !self.exists(b.dataset.v);
          var on = mode === 'slots' ? st.slots.slice(0, st.pack).some(function (x) { return x && norm(x) === n; }) && norm(curS) === n : (scent && norm(scent) === n);
          if (mode === 'slots') on = st.slots.slice(0, st.pack).map(norm).indexOf(n) > -1;
          b.setAttribute('aria-pressed', String(!!on));
          var av = self.available(b.dataset.v); b.classList.toggle('is-soldout', !av); b.disabled = !av;
        });
      }
      // destinations
      if (el.optPick) {
        var refS = mode === 'slots' ? (st.slots[st.slot] || st.slots.filter(Boolean)[0]) : scent;
        el.optPick.querySelectorAll('[data-cs-city]').forEach(function (b) {
          var on = !!city && norm(b.dataset.csCity) === norm(city);
          b.setAttribute('aria-pressed', String(on));
          var c = norm(b.dataset.csCity), pv = d.variants.filter(function (x) { return norm(x.o[self.ci]) === c && (!refS || norm(x.o[self.si]) === norm(refS)); })[0] || d.variants.filter(function (x) { return norm(x.o[self.ci]) === c; })[0];
          var ps = b.querySelector('[data-cs-opt-price]'); if (ps) ps.textContent = pv ? self.money(pv.p) : '';
        });
      }
      if (el.cityPick) el.cityPick.querySelectorAll('[data-cs-city]').forEach(function (b) { b.setAttribute('aria-pressed', String(!!city && norm(b.dataset.csCity) === norm(city))); });
      // duo
      if (el.format && mode === 'duo') {
        el.format.querySelectorAll('[data-cs-fmt]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.dataset.csFmt === 'duo') === isDuo)); });
        var sub = el.format.querySelector('[data-cs-fmt-sub="single"]'); if (sub && !sub.textContent.trim()) sub.textContent = this.money(unitCents);
        var sd = el.format.querySelector('[data-cs-fmt-sub="duo"]'); if (sd) sd.textContent = this.tpl(sd.dataset.tpl, { price: this.eur(d.duoPrice) });
        el.duo2.hidden = !isDuo;
        if (isDuo) {
          el.duo2Name.textContent = st.scent2 || '';
          var save = unitCents * 2 / 100 - d.duoPrice; el.duo2Save.textContent = save > 0 ? 'économie ' + this.eur(save) : '';
          el.chips2.querySelectorAll('.cs-chip').forEach(function (b) { b.setAttribute('aria-pressed', String(norm(b.dataset.v) === norm(st.scent2))); });
        }
        if (el.qty) el.qty.hidden = isDuo;
      }
      // packs / emplacements
      if (mode === 'slots') {
        if (el.slots) {
          el.slots.innerHTML = '';
          for (var i = 0; i < st.pack; i++) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'cs-slot'; b.dataset.csSlot = i; b.setAttribute('aria-pressed', String(i === st.slot));
            var val = st.slots[i];
            b.innerHTML = '<span class="cs-chip__dot"></span><span><small>' + this.cap(this.packUnit[0]) + ' ' + (i + 1) + '</small><span></span></span>';
            b.querySelector('.cs-chip__dot').style.setProperty('--c', val ? this.colorFor(val) : '#D9CFC0');
            b.querySelector('small + span').textContent = val || 'Choisir un parfum';
            el.slots.appendChild(b);
          }
        }
        if (el.same) el.same.hidden = st.pack < 2;
        el.packs.forEach(function (b) {
          var n = +b.dataset.csPack, total = self.packTotal(n, unitCents);
          b.setAttribute('aria-pressed', String(n === st.pack));
          b.querySelector('[data-cs-pack-total]').textContent = self.eur(total);
          b.querySelector('[data-cs-pack-unit]').textContent = n > 1 ? self.eur(total / n) + ' l\'unité' : 'prix unitaire';
          var sv = (unitCents / 100) * n - total; b.querySelector('[data-cs-pack-save]').textContent = n > 1 && sv > 0.004 ? 'économie ' + self.eur(sv) : '';
        });
      }

      // carte de sélection
      var names = [];
      if (mode === 'slots') names = uniq(st.slots.slice(0, st.pack).filter(Boolean));
      else if (mode === 'riviera') names = [city, scent].filter(Boolean);
      else names = isDuo ? [scent, st.scent2].filter(Boolean) : (scent ? [scent] : []);
      if (this.boxes && this.boxes.length) {
        names = this.boxes.map(function (bx) { return st.box[bx.dataset.prop]; }).filter(Boolean).concat(names);
        this.boxes.forEach(function (bx) {
          var cur = st.box[bx.dataset.prop];
          bx.querySelectorAll('[data-cs-box-v]').forEach(function (b) { b.setAttribute('aria-pressed', String(!!cur && norm(b.dataset.csBoxV) === norm(cur))); });
        });
        if (this.boxSum) {
          this.boxSum.querySelectorAll('li').forEach(function (li) {
            var val = li.hasAttribute('data-cs-sum-main') ? scent : st.box[li.dataset.csSum];
            var b = li.querySelector('[data-cs-sum-v]');
            if (b.dataset.empty == null) b.dataset.empty = b.textContent;
            b.textContent = val || b.dataset.empty; li.classList.toggle('is-on', !!val);
            li.querySelector('.cs-boxsum__dot').style.setProperty('--c', val ? self.colorFor(val) : '#D9CFC0');
          });
        }
      }
      var dotName = mode === 'riviera' ? (city || scent) : (mode === 'slots' ? names[0] : scent);
      var dotColor = dotName ? this.colorFor(dotName) : '#D9CFC0';
      if (el.selDot) el.selDot.style.setProperty('--cs-dot', dotColor), el.selDot.style.background = dotColor;
      if (el.sel) {
        el.selK.textContent = names.length ? el.sel.dataset.onLabel : this.tpl(el.sel.dataset.emptyLabel, { count: this.values.length });
        el.selN.textContent = names.length ? names.join(mode === 'riviera' ? ' × ' : ' + ') : 'Choisissez votre sélection';
        if (!names.length) el.selN.textContent = mode === 'riviera' ? 'Choisissez votre destination' : 'Choisissez votre parfum';
      }
      if (this.hasRiv) { el.rivCity.textContent = city || 'Votre destination'; el.rivScent.textContent = scent || 'Votre parfum'; }

      // détails de la senteur (accordéon alimenté par le champ variante custom.senteur)
      var sdBody = this.querySelector('[data-cs-sd-body]');
      if (sdBody) {
        if (this.sdMap === undefined) { var sdE = this.querySelector('[data-cs-sd-data]'); try { this.sdMap = sdE ? JSON.parse(sdE.textContent) : null; } catch (err) { this.sdMap = null; } }
        var sdKey = mode === 'slots' ? (st.slots[st.slot] || st.slots[0]) : scent;
        if (sdKey !== this.sdLast) {
          this.sdLast = sdKey; var sdHtml = '';
          if (sdKey && this.sdMap) { Object.keys(this.sdMap).forEach(function (k) { if (norm(k) === norm(sdKey)) sdHtml = self.sdMap[k]; }); }
          sdBody.innerHTML = sdHtml || '<p class="cs-sd__empty">' + (sdKey ? 'Aucun détail disponible pour ce parfum.' : 'Choisissez un parfum pour afficher ses détails.') + '</p>';
        }
      }

      // pictogrammes (onglet alimenté par le champ variante custom.pictogrammes)
      var picBody = this.querySelector('[data-cs-pic-body]');
      if (picBody) {
        if (this.picMap === undefined) { var picE = this.querySelector('[data-cs-pic-data]'); try { this.picMap = picE ? JSON.parse(picE.textContent) : null; } catch (err) { this.picMap = null; } }
        var picKey = mode === 'slots' ? (st.slots[st.slot] || st.slots[0]) : scent;
        if (picKey !== this.picLast) {
          this.picLast = picKey; var picHtml = '';
          if (picKey && this.picMap) { Object.keys(this.picMap).forEach(function (k) { if (norm(k) === norm(picKey)) picHtml = self.picMap[k]; }); }
          picBody.innerHTML = picHtml; var picAcc = picBody.closest('[data-cs-pic]'); if (picAcc) picAcc.hidden = !picHtml;
        }
      }

      // prix
      var priceCents, subTxt = '', compare = 0;
      if (isDuo) { priceCents = d.duoPrice * 100; }
      else if (mode === 'slots') { priceCents = Math.round(this.packTotal(st.pack, unitCents) * 100); }
      else { priceCents = unitCents; compare = v ? v.c : 0; }
      if (el.priceV) {
        el.priceV.innerHTML = this.money(priceCents) + (compare > priceCents ? ' <s>' + this.money(compare) + '</s>' : '');
        var base = el.price.dataset.sub || '';
        if (isDuo) subTxt = this.tpl(el.price.dataset.subDuo, { regular: this.money(unitCents * 2) });
        else if (mode === 'slots') subTxt = st.pack + ' ' + this.packUnit[st.pack > 1 ? 1 : 0] + ' · ' + this.eur(priceCents / 100 / st.pack) + ' l\'unité';
        else subTxt = base;
        el.priceS.textContent = subTxt;
      }

      // vente additionnelle
      var upScent = mode === 'slots' ? (st.slots.filter(Boolean)[0] || null) : scent;
      var up, upOn = false;
      if (el.up && el.up.dataset.choose) {
        up = this.upChoose(mode === 'slots' ? upScent : (mode === 'riviera' ? city : scent));
        el.up.hidden = !up;
        if (up) {
          el.up.querySelector('[data-cs-upsell-t]').textContent = el.up.dataset.title;
          el.up.querySelector('[data-cs-upsell-s]').textContent = el.up.dataset.sub;
          el.up.querySelector('[data-cs-upsell-p]').textContent = '+' + this.money(up.p);
          el.upIn.disabled = !up.a; upOn = st.up && up.a; el.upIn.checked = upOn;
          var upSel = el.up.querySelector('[data-cs-upsell-sel]'); upSel.hidden = !st.up;
          [].forEach.call(upSel.querySelectorAll('select'), function (sl, i) { sl.value = st.upSel[i]; });
        }
      } else {
        up = this.upsellVariant(upScent, city, mode);
        if (el.up) {
          if (up && (mode === 'riviera' ? !!city : !!upScent)) {
            el.up.hidden = false;
            var nm = mode === 'riviera' ? city : upScent;
            el.up.querySelector('[data-cs-upsell-t]').textContent = this.tpl(el.up.dataset.title, { scent: nm, city: nm, up: up.o.join(' / ') });
            el.up.querySelector('[data-cs-upsell-s]').textContent = el.up.dataset.sub;
            el.up.querySelector('[data-cs-upsell-p]').textContent = '+' + this.money(up.p);
            el.upIn.disabled = !up.a; upOn = st.up && up.a; el.upIn.checked = upOn;
          } else { el.up.hidden = true; upOn = false; }
        }
      }
      if (el.up && up && up.img) { var upImg = el.up.querySelector('[data-cs-upsell-img]'); if (upImg && upImg.getAttribute('src') !== up.img) upImg.src = up.img; }
      this.upV = upOn ? up : null;

      // bouton
      var atc = el.atc, ctaTxt;
      var total = priceCents * (mode === 'standard' || mode === 'riviera' ? st.qty : 1) + (this.upV ? this.upV.p : 0);
      if (!complete) ctaTxt = atc.dataset.ctaPick;
      else if (!this.canBuy()) ctaTxt = 'Indisponible';
      else if (isDuo) ctaTxt = atc.dataset.ctaDuo + ' — ' + this.money(total);
      else if (mode === 'slots') ctaTxt = this.tpl(atc.dataset.ctaPack.replace('recharge(s)', this.packUnit[st.pack > 1 ? 1 : 0]), { n: st.pack, unit: this.packUnit[st.pack > 1 ? 1 : 0] }) + ' — ' + this.money(total);
      else ctaTxt = atc.dataset.ctaAdd + ' — ' + this.money(total);
      el.cta.textContent = ctaTxt; el.cta.disabled = complete && !this.canBuy();
      if (el.qtyV) el.qtyV.textContent = st.qty;
      this.ctaTxt = ctaTxt;

      // sticky
      if (el.sticky) {
        el.stT.textContent = names.length ? names.join(mode === 'riviera' ? ' × ' : ' + ') : d.title;
        el.stS.textContent = (isDuo ? 'Duo' : d.title.split(' ').slice(0, 3).join(' ')) + ' · ' + this.money(priceCents);
        el.stDot.style.background = dotColor;
        el.stCta.textContent = complete ? (mode === 'slots' || isDuo ? 'Ajouter' : (window.innerWidth < 760 ? 'Ajouter' : atc.dataset.ctaAdd)) : atc.dataset.ctaPick;
      }

      // galerie + URL
      var tint = dotColor;
      el.slides.forEach(function (s) { if (s.classList.contains('cs-ph--empty')) s.style.setProperty('--cs-tone', tint); });
      var autoMedia = true;
      // recharges (mode « slots ») : la photo suit le parfum de l'emplacement actif
      var mv = v;
      if (mode === 'slots') { var ms = st.slots[st.slot] || st.slots[0]; mv = ms ? this.variantOf(ms) : null; }
      // destination choisie sans parfum : la photo suit quand même la destination
      if (!mv && this.ci > -1 && city) mv = d.variants.filter(function (x) { return norm(x.o[self.ci]) === norm(city); }).sort(function (x, y) { return (y.a ? 1 : 0) - (x.a ? 1 : 0); })[0] || null;
      if (first) { this.paintGallery(); if (mv && autoMedia) this.showVariantMedia(mv, true); }
      else if (mediaToo !== false && mv && autoMedia) this.showVariantMedia(mv);
      if (v && mode !== 'slots' && !first) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) { /* noop */ }
      }
      if (el.err) el.err.hidden = true;
    }

    canBuy() {
      var d = this.d, st = this.st;
      if (d.mode === 'slots') return st.slots.slice(0, st.pack).every(function (s) { var v = this.variantOf(s); return v && v.a; }, this);
      if (!this.v || !this.v.a) return false;
      if (d.mode === 'duo' && st.duo) { var v2 = this.variantOf(st.scent2); return !!(v2 && v2.a); }
      return true;
    }

    upChoose(key) {
      var u = this.d.upsell, st = this.st, self = this; if (!u || !u.variants.length) return null;
      var same = function (a, b) { return a.length === b.length && a.every(function (x, i) { return x === b[i]; }); };
      var find = function (o) { return u.variants.filter(function (v) { return same(v.o, o); })[0]; };
      if (!this.upBuilt) {
        this.upBuilt = true;
        var box = this.el.up.querySelector('[data-cs-upsell-sel]'); if (!box) return null;
        (u.options || []).forEach(function (name, i) {
          var vals = uniq(u.variants.map(function (v) { return v.o[i]; }));
          if (vals.length < 2) return;
          var lab = document.createElement('label'); lab.className = 'cs-up__f';
          var sp = document.createElement('span'); sp.textContent = /^visuel$/i.test(name) ? 'Destination' : name; lab.appendChild(sp);
          var sl = document.createElement('select');
          vals.forEach(function (x) { var op = document.createElement('option'); op.value = x; op.textContent = x; sl.appendChild(op); });
          sl.addEventListener('change', function () {
            st.upTouched = true; var o = st.upSel.slice(); o[i] = sl.value;
            if (!find(o)) o = u.variants.filter(function (v) { return v.o[i] === sl.value; })[0].o.slice();
            st.upSel = o; self.render();
          });
          lab.appendChild(sl); box.appendChild(lab);
        });
      }
      if (!st.upSel || (!st.upTouched && st.upFor !== key)) {
        st.upFor = key; var n = key ? norm(key) : '';
        var hit = n && u.variants.filter(function (v) { return v.a && v.o.some(function (o) { return norm(o) === n; }); })[0];
        st.upSel = (hit || u.variants.filter(function (v) { return v.a; })[0] || u.variants[0]).o.slice();
      }
      return find(st.upSel) || null;
    }

    upsellVariant(scent, city, mode) {
      var u = this.d.upsell; if (!u) return null;
      var key = mode === 'riviera' || this.d.upsellMatch === 'city' ? city : scent; if (!key) return null;
      var n = norm(key), mapped = this.upMap[n] || n;
      var hit = u.variants.filter(function (v) { return v.o.some(function (o) { return norm(o) === mapped; }); })[0];
      if (!hit && this.d.upsellMatch === 'city') hit = u.variants.filter(function (v) { return v.o.some(function (o) { return norm(o).indexOf(mapped) > -1 || mapped.indexOf(norm(o)) > -1; }); })[0];
      return hit || null;
    }

    /* ---------- achat ---------- */
    action() {
      if (!this.complete) { this.scrollToPick(); return; }
      if (!this.canBuy()) return;
      this.add();
    }
    buildItems() {
      var d = this.d, st = this.st, map = {}, order = [];
      var push = function (id, q) { if (!map[id]) { map[id] = 0; order.push(id); } map[id] += q; };
      if (d.mode === 'slots') st.slots.slice(0, st.pack).forEach(function (s) { push(this.variantOf(s).id, 1); }, this);
      else if (d.mode === 'duo' && st.duo) { push(this.v.id, 1); push(this.variantOf(st.scent2).id, 1); }
      else push(this.v.id, st.qty);
      if (this.upV) push(this.upV.id, (d.mode === 'duo' && st.duo) ? 1 : (d.mode === 'slots' ? 1 : st.qty));
      var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
      if (this.boxes && this.boxes.length && this.v) {
        var props = {}, any = false;
        this.boxes.forEach(function (bx) { var val = st.box[bx.dataset.prop]; if (val) { props[bx.dataset.prop] = val; any = true; } });
        if (this.note && this.note.value.trim()) { props[this.note.dataset.prop] = this.note.value.trim(); any = true; }
        if (any) items.forEach(function (it) { if (it.id === this.v.id) it.properties = props; }, this);
      }
      return items;
    }
    add() {
      var self = this, el = this.el;
      el.cta.classList.add('is-loading'); el.err.hidden = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: this.buildItems() }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Impossible d\'ajouter au panier.'); return j; }); })
        .then(function () { self.afterAdd(); })
        .catch(function (e) { el.err.textContent = e.message; el.err.hidden = false; })
        .then(function () { el.cta.classList.remove('is-loading'); });
    }
    afterAdd() {
      this.loadCart();
      try { if (window.T4SThemeSP && T4SThemeSP.Cart && T4SThemeSP.Cart.getToFetch) T4SThemeSP.Cart.getToFetch(); } catch (e) { /* noop */ }
      setTimeout(function () {
        var trg = document.querySelector('a[data-drawer-options*="t4s-mini_cart"]');
        if (trg) trg.click(); else location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      }, 350);
      document.dispatchEvent(new CustomEvent('cs:added', { detail: { items: this.buildItems() } }));
    }
    loadCart() {
      var self = this;
      if (!this.el.ship) return;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.paintShip(c.total_price / 100); })
        .catch(function () { self.paintShip(0); });
    }
    paintShip(total) {
      var th = this.d.freeShip, el = this.el;
      el.shipBar.style.width = Math.min(100, (total / th) * 100) + '%';
      el.shipMsg.textContent = total >= th ? 'La livraison vous est offerte.' : total > 0 ? 'Plus que ' + this.eur(th - total) + ' pour la livraison offerte.' : 'Livraison offerte dès ' + this.eur(th) + ' d\'achat.';
    }
    watchSticky() {
      var self = this, el = this.el; if (!el.sticky || !el.atc || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) {
        var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.sticky.classList.toggle('is-on', on); el.sticky.setAttribute('aria-hidden', String(!on));
      }).observe(el.atc);
    }
  }
  customElements.define('cs-product', CsProduct);
})();
